const CONFIG = {
  pendiente:  { bg: '#fef3c7', color: '#92400e', label: 'Pendiente' },
  enviado:    { bg: '#dbeafe', color: '#1e40af', label: 'Enviado' },
  confirmado: { bg: '#dcfce7', color: '#166534', label: 'Confirmado' },
  acreditado: { bg: '#bbf7d0', color: '#14532d', label: 'Acreditado' },
  error:      { bg: '#fee2e2', color: '#991b1b', label: 'Error' },
  anulado:    { bg: '#f1f5f9', color: '#64748b', label: 'Anulado' },
  rechazado:  { bg: '#fee2e2', color: '#991b1b', label: 'Rechazado' },
  devuelto:   { bg: '#fed7aa', color: '#9a3412', label: 'Devuelto' },
}

// `fallido`: la membresía que la pasarela no pudo cobrar (el pago va como
// rechazado y pasa a confirmado solo cuando el cobro entra — 10 oct 2026).
// `aDevolver`: venta descartada por fraude con la plata ya cobrada (19 oct 2026).
export default function EstadoBadgePago({ estado, fallido = false, aDevolver = false }) {
  const cfg = aDevolver
    ? { ...CONFIG.rechazado, label: 'A devolver' }
    : fallido
      ? { ...CONFIG.rechazado, label: 'Cobro fallido' }
      : (CONFIG[estado] || { bg: '#f1f5f9', color: '#64748b', label: estado })
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
      background: cfg.bg,
      color: cfg.color,
    }}>
      {cfg.label}
    </span>
  )
}
